
<style>
    .form-material select, .form-material input, .form-material textarea, languageSelector select {
      width: 100%;
      font-size:14px;
    }

  .form-material select {
    font-size:14px;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  .languageContainer {
    display:block;
    margin-bottom:10px;
  }

  .globalContainer {
    display:block;
    margin-bottom:10px;
    padding:12px;
  }

  textarea {min-height: 100px;}

  </style>

  <app-modal-header [headerTitle]="'Edit Pronunciation'"></app-modal-header>


  <div class="globalContainer" *ngIf="item != null">
 
    <div class="form-group row">

        <div class="col-12">
            <div class="form-material">
            <input matInput [(ngModel)]="item.Text">
            <label for="">Text</label>
            </div>
        </div>

        <div class="col-12">
          <div class="form-material">
              <input matInput [(ngModel)]="item.PronunciationHtml"/>
              <label for="">Pronunciation HTML</label>
          </div>
        </div>

      <div class="col-12"> 
          <div class="cbRow">
            <div class=""><input type="checkbox" [(ngModel)]="item.IsActive"/></div>
            <div class=""><label for="">Is Active</label></div> 
          </div>
      </div>


    </div> 

  </div>


  <div mat-dialog-actions class="float-right">
  <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
  <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>

  </div>
